import { render, staticRenderFns } from "./DataViewCamSidebar.vue?vue&type=template&id=224c1425&scoped=true&"
import script from "./DataViewCamSidebar.vue?vue&type=script&lang=js&"
export * from "./DataViewCamSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DataViewCamSidebar.vue?vue&type=style&index=0&id=224c1425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c1425",
  null
  
)

export default component.exports